import { render, staticRenderFns } from "./AddSectionButton.vue?vue&type=template&id=09df4776&"
import script from "./AddSectionButton.vue?vue&type=script&lang=ts&"
export * from "./AddSectionButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports